import React from 'react';
import { Link } from 'react-router-dom';

const GamesExplorationsSection = ({ explorations }) => {
  return (
    <section aria-labelledby="games-experiments-title" className="mb-20">
      <div className="max-w-2xl mx-auto text-center">
        <h2
          id="games-experiments-title"
          className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
        >
          Exploracoes e APIs
        </h2>
        <p className="mt-4 text-lg text-gray-600">
          Um espaco para testes rapidos com APIs publicas e ideias de front-end.
        </p>
      </div>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
        {explorations.map((exploration) => (
          <div
            key={exploration.id}
            className={`bg-gradient-to-br from-slate-50 via-white to-blue-50 rounded-xl border border-slate-200 shadow-lg site-card shadow-slate-200/70 overflow-hidden transition hover:-translate-y-0.5 hover:shadow-xl hover:shadow-slate-200/80 ${
              exploration.containerClassName || ''
            }`}
          >
            <div className="p-6">
              <p className="text-sm font-semibold text-sky-700">{exploration.eyebrow}</p>
              <h3 className="mt-2 text-2xl font-semibold text-gray-900">{exploration.title}</h3>
              <p className="mt-3 text-gray-600">{exploration.description}</p>
              <div className="mt-6">
                <Link
                  to={exploration.to}
                  className="inline-flex items-center rounded-md bg-slate-800 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-slate-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700"
                >
                  Abrir exploracao
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default GamesExplorationsSection;
